import { PButton } from "./PButton";
import { PDialog } from "./PDialog";
import { PrimeGlyph } from "./PrimeGlyph";
import type { PrimeGlyphName } from "./prime-glyphs";

// THE APP-WIDE `p-confirmDialog` (`app.component.html`, KEY `confirmDialog`): A `p-dialog`
// WITH A 2REM ICON AND THE MESSAGE 1REM TO ITS RIGHT, AND A FOOTER OF A TEXT-STYLE REJECT
// BUTTON THEN THE ACCEPT BUTTON, NEITHER WITH AN ICON (`acceptIcon` / `rejectIcon` "none").
// `acceptColor` IS THE CALLER'S `acceptButtonStyleClass` (E.G. `bg-danger` = `--red-500`).
export function PConfirmDialog(props: {
  open: boolean;
  header: string;
  message: string;
  icon?: PrimeGlyphName;
  acceptLabel?: string;
  rejectLabel?: string;
  acceptColor?: string;
  loading?: boolean;
  onAccept: () => void;
  onReject: () => void;
}) {
  const { open, header, message, icon = "info-circle", acceptLabel = "Yes", rejectLabel = "No", acceptColor, loading, onAccept, onReject } = props;
  return (
    <PDialog
      open={open}
      onClose={onReject}
      ariaLabel={header}
      header={header}
      footer={
        <>
          <PButton label={rejectLabel} variant="text" onClick={onReject} />
          <PButton label={acceptLabel} loading={loading} onClick={onAccept} sx={acceptColor ? { backgroundColor: acceptColor, "&:hover": { backgroundColor: acceptColor } } : undefined} />
        </>
      }
    >
      <div className="flex align-items-center">
        <PrimeGlyph name={icon} size="2rem" />
        <span style={{ marginLeft: "1rem" }}>{message}</span>
      </div>
    </PDialog>
  );
}
